import MessageBubble from './MessageBubblePresenter';

export default MessageBubble;
